export const filterArray = (filters: any, data: any, condition: string) => {
  return data.filter((item: any) => {
    return filters.some((filter: any) => {
      return item[condition]?.toLowerCase() === filter.toLowerCase();
    });
  });
};
